import React from 'react';
import {dashboardText} from '../dashboardText';
import Button from '../../../uiToolkit/Buttons/Button';
import Tooltip2 from '../../../uiToolkit/Tooltip2/Tooltip2';

interface Props {
  onBuyAddons: () => void;
  creatorsAmount: number;
  totalCreatorsAmount: string;
  allowAddingCreators: boolean;
  showTotalCreators: boolean;
}

const CreatorsCard = React.memo(
  ({
    onBuyAddons,
    creatorsAmount,
    totalCreatorsAmount,
    allowAddingCreators,
    showTotalCreators,
  }: Props) => {
    return (
      <div className="DashboardCard CreatorsCard">
        <div className="d-flex flex-row justify-content-between">
          <p className="Title">{dashboardText.creators}</p>
          <Tooltip2
            text={dashboardText.availableOnlyForBusinessPlan}
            hidden={allowAddingCreators}>
            <Button
              uiType="hollow"
              onClick={onBuyAddons}
              title={dashboardText.addCreators}
              icon="icon-icon_plus_circle"
              disabled={!allowAddingCreators}
            />
          </Tooltip2>
        </div>
        <div className="CardCenteredBody">
          <h3 className="AiCredits">
            {showTotalCreators
              ? `${creatorsAmount} / ${totalCreatorsAmount}`
              : creatorsAmount}
          </h3>
        </div>
      </div>
    );
  },
);

export default CreatorsCard;
